// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const categoriesList = "CategoriesList__categoriesList__SsbUz";
export const item = "CategoriesList__item__oE73H";
export const shaded = "CategoriesList__shaded__kDDCa";
export const itemPoint = "CategoriesList__itemPoint__Oh2ga";
export const itemText = "CategoriesList__itemText__UTxtl font-faces__sansMedium__DqLMY font-faces__sans__uCf65";